import { render, staticRenderFns } from "./BillingDetailPanel.vue?vue&type=template&id=68c2bbbf&scoped=true&"
import script from "./BillingDetailPanel.vue?vue&type=script&lang=js&"
export * from "./BillingDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetailPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BillingDetailPanel.vue?vue&type=style&index=1&id=68c2bbbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2bbbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCheckbox,VContainer,VDivider})
